import { AfterViewInit, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { UserPreferences } from 'src/app/user-management/models/user-preferences.model';
import { User } from 'src/app/user-management/models/user.model';
import { MaterialInputAppearance } from '../models/generic-resource-model';
import { AuthService } from './auth.service';

declare const $: any;
const md: any = {
  misc: {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
  }
};

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {

  defaultUserPreferences: UserPreferences = new UserPreferences({
    id: 0,
    imageName: "./assets/img/sidebar-1.jpg",
    //sideBarBackgroundColor: "azure",
    sideBarBackgroundColor: "white",
    sideBarFilterColor: "lightblue1",
    sideBarImageEnabled: false,
    sideBarMiniEnabled: false,
  });

  private _selectionColor: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundColor: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundImage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundImageEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _sideBarMiniEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _inputAppearance: BehaviorSubject<MaterialInputAppearance> = new BehaviorSubject<MaterialInputAppearance>(null);
  private _languague: string = "en";

  constructor(private translateService: TranslateService, private authService: AuthService) {
    // let userPreferences: UserPreferences = this.currentUserPreferencesValue;
    // this.authService.currentUserSubs.subscribe()
    // let useDefaultSettings: boolean = userPreferences == null;
    // this._selectionColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarFilterColor : userPreferences.sideBarFilterColor);
    // this._backgroundColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarBackgroundColor : userPreferences.sideBarBackgroundColor);
    // this._backgroundImage.next(useDefaultSettings? this.defaultUserPreferences.imageName : userPreferences.imageName);
    // this._backgroundImageEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarImageEnabled : userPreferences.sideBarImageEnabled);
    // this._sideBarMiniEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarMiniEnabled : userPreferences.sideBarMiniEnabled);
    // this._inputAppearance.next(localStorage.getItem('matInputAppearance') as MaterialInputAppearance);
    this._languague = localStorage.getItem('languageSetting');

    if (this._languague) {
      this.translateService.use(this._languague);
    }

  }

  public reloadUserPreferences() {
    let userPreferences: UserPreferences = this.currentUserPreferencesValue;
    let useDefaultSettings: boolean = userPreferences == null || userPreferences == undefined;
    this._selectionColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarFilterColor : userPreferences.sideBarFilterColor);
    this._backgroundColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarBackgroundColor : userPreferences.sideBarBackgroundColor);
    this._backgroundImage.next(useDefaultSettings? this.defaultUserPreferences.imageName : userPreferences.imageName);
    this._backgroundImageEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarImageEnabled : userPreferences.sideBarImageEnabled);
    this._sideBarMiniEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarMiniEnabled : userPreferences.sideBarMiniEnabled);
    this.applyPreferences();
  }

  public applyPreferences() {
    if (this._selectionColor.value) {
      this.updateSelectionColorUI(this._selectionColor.value);
    }
    if (this._backgroundColor.value) {
      this.updateBackgroundColorUI(this._backgroundColor.value);
    }
    if (this._backgroundImage.value) {
      this.updateBackgroundImageUI(this._backgroundImage.value);
    }
    // if (this._backgroundImageEnabled.value) {
    //   this.updateBackgroundImageEnabled(this._backgroundImageEnabled.value);
    // }
    if (this._sideBarMiniEnabled.value) {
      this.updateSidebarMiniEnabled(this._sideBarMiniEnabled.value);
    }
  }

  public changeLanguage(lang: string | undefined) {
    if (!lang) {
      return;
    }
    this._languague = lang;
    localStorage.setItem('languageSetting', lang);
    this.translateService.use(lang);
  }

  public updateBackgroundImageUI(image: string) {

    let $sidebar = $('.sidebar');
    let $sidebar_img_container = $sidebar.find('.sidebar-background');
    let $sidebar_responsive = $('body > .navbar-collapse');
    let $full_page_background = $('.full-page-background');

    if ($sidebar_img_container.length !== 0 && this._backgroundImageEnabled.value == true) {
      $sidebar_img_container.fadeOut('fast', function () {
        $sidebar_img_container.css('background-image', 'url("' + image + '")');
        $sidebar_img_container.fadeIn('fast');
      });
    }

    if ($full_page_background.length !== 0 && this._backgroundImageEnabled.value == true) {
      // let new_image_full_page = $('.fixed-plugin li.active .img-holder').find('img').data('src');
      // if (new_image_full_page == undefined){
      //   new_image_full_page = image;
      // }
      $full_page_background.fadeOut('fast', function () {
        $full_page_background.css('background-image', 'url("' + image + '")');
        $full_page_background.fadeIn('fast');
      });
    }

    if (this._backgroundImageEnabled.value == true) {
      // let image2 = $('.fixed-plugin li.active .img-holder').find('img').attr('src');
      // let new_image_full_page = $('.fixed-plugin li.active .img-holder').find('img').data('src');
      // if (new_image_full_page == undefined || image2 == undefined){
      //   new_image_full_page = image;
      // }
      $sidebar_img_container.css('background-image', 'url("' + image + '")');
      $full_page_background.css('background-image', 'url("' + image + '")');
    }

    if ($sidebar_responsive.length !== 0) {
      $sidebar_responsive.css('background-image', 'url("' + image + '")');
    }
  }

  public updateBackgroundColorUI(color: string) {
    let $sidebar = $('.sidebar');
    if ($sidebar.length !== 0) {
      $sidebar.attr('data-background-color', color);
    }
  }

  public updateSelectionColorUI(color: string) {

    let $sidebar = $('.sidebar');
    let $full_page = $('.full-page');
    let $sidebar_responsive = $('body > .navbar-collapse');

    if ($sidebar.length !== 0) {
      $sidebar.attr('data-color', color);
    }

    if ($full_page.length !== 0) {
      $full_page.attr('filter-color', color);
    }

    if ($sidebar_responsive.length !== 0) {
      $sidebar_responsive.attr('data-color', color);
    }
  }

  public updateBackgroundImageEnabled(value: boolean) {

  }

  public updateSidebarMiniEnabled(value: boolean) {
    if (value == false) {
      $('body').removeClass('sidebar-mini');
      md.misc.sidebar_mini_active = false;
    }

    if (value == true) {
      setTimeout(function () {
        $('body').addClass('sidebar-mini');
        $('.sidebar .collapse').css('height', 'auto');
        md.misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  public get currentUserPreferencesValue(): UserPreferences | null {
    return this.authService.currentUserValue?.preferences;
  }

  public set currentUserPreferencesValue(preferences: UserPreferences) {
    if (preferences == null) {
      return;
    }
    let user: User = this.authService.currentUserValue;
    if (!user) return;
    user.preferences = preferences;
    this.authService.currentUserValue = user;
  }

  get language() {
    return this._languague;
  }

  get selectionColor() {
    return this._selectionColor.value;
  }

  set selectionColor(color: string) {
    if (!color) {
      return;
    }

    this.updateSelectionColorUI(color);
    // localStorage.setItem('selectionColor', color);
    this._selectionColor.next(color);
  }

  get backgroundColor() {
    return this._backgroundColor.value;
  }

  set backgroundColor(color: string) {
    if (!color) {
      return;
    }

    this.updateBackgroundColorUI(color);
    // localStorage.setItem('bgColor', color);
    this._backgroundColor.next(color);
  }

  get backgroundImage() {
    return this._backgroundImage.value;
  }

  set backgroundImage(image: string) {
    if (!image) {
      return;
    }
    this.updateBackgroundImageUI(image);
    // localStorage.setItem('bgImage', image);
    this._backgroundImage.next(image);
  }

  get backgroundImageEnabled() {
    return this._backgroundImageEnabled.value;
  }

  get backgroundImageEnabledBehavior() {
    return this._backgroundImageEnabled;
  }

  set backgroundImageEnabled(value: boolean) {
    // let valueBoolean = JSON.stringify(value)
    this.updateBackgroundImageEnabled(value);
    // localStorage.setItem('bgImageEnabled', valueBoolean);
    this._backgroundImageEnabled.next(value);
  }

  get sideBarMiniEnabled() {
    return this._sideBarMiniEnabled.value;
  }

  set sideBarMiniEnabled(value: boolean) {
    // let valueBoolean = JSON.stringify(value)
    this.updateSidebarMiniEnabled(value);
    // localStorage.setItem('sideBarMiniEnabled', valueBoolean);
    this._sideBarMiniEnabled.next(value);
  }

  get inputAppearance() {
    return this._inputAppearance.value;
  }

  get inputAppearanceBehavior() {
    return this._inputAppearance;
  }

  set inputAppearance(type: MaterialInputAppearance) {
    if (!type) {
      return;
    }

    this._inputAppearance.next(type);
  }
}
